/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import UCButton from "../../buttons";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const Content = (props) => {
  const { setShowModal, setAssignModalShow } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const handleLeave = () => {
    setShowModal(false);
    setAssignModalShow(false);
  };

  return (
    <div>
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="lepUnsavedChangesModal.cancel" />}
              />
            </Col>
            <Col className={classes.colLeave}>
              <UCButton
                className={classes.leaveBtn}
                onClick={handleLeave}
                type="danger"
                text={<FormattedMessage id="lepUnsavedChangesModal.leave" />}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  );
};

export default Content;
